// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as FlightLandingActions } from '../duck';
import FlightLanding from '../components/FlightLanding/FlightLanding';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    isFetchingFlight: state.flightLanding.isFetchingFlight,
    flight: state.flightLanding.flight,
    fetchFlightError: state.flightLanding.fetchFlightError,
    isSavingData: state.flightLanding.isSavingData,
    locale: state.locale,
    user: state.auth.user,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ ...FlightLandingActions }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(FlightLanding);



// WEBPACK FOOTER //
// ./src/modules/flight-landing/containers/FlightLandingContainer.js